import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import api from "../../../api";
import OwlCarousel from "react-owl-carousel";
import { FaRegNewspaper } from "react-icons/fa";

const BlogSection = () => {
  const [articles, setArticles] = useState([]);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);

  // Fetch blogs
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await api.get("/blogs");
        setArticles(response.data.data || []);
      } catch (err) {
        setError(err);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, []);

  // Carousel settings
  const carouselOptions = {
    loop: true,
    margin: 24,
    nav: true,
    dots: false,
    autoplay: true,
    autoplayTimeout: 4200,
    autoplayHoverPause: true,
    responsive: {
      0: { items: 1 },
      600: { items: 2 },
      1000: { items: 4 },
    },
  };

  // Strip HTML tags from description
  const stripTags = (html) => html.replace(/<\/?[^>]+(>|$)/g, "");

  // Modern blog card
  const renderBlogCard = (article) => (
    <div className="news-block px-2" key={article.id} style={{ minHeight: 350 }}>
      <div className="blog-card-modern bg-white rounded-4 shadow-sm h-100 d-flex flex-column position-relative overflow-hidden">
        {/* Image */}
        <div
          className="blog-image-wrapper"
          style={{
            width: "100%",
            height: "230px",
            overflow: "hidden",
            background: "#f4f4f4",
            margin: "0 auto",
            boxShadow: "0 4px 24px rgba(7, 7, 8, 0.1)",
          }}
        >
          <Link to={`/blog/${article.slug}`} style={{ display: "block", width: "100%", height: "100%" }}>
            <img
              src={article.banner}
              alt={article.title}
              className="img-fluid w-100 h-100"
              style={{ objectFit: "cover" }}
            />
          </Link>
        </div>

        {/* Content */}
        <div className="content-box flex-grow-1 d-flex flex-column p-4 pb-3">
          <h4
            className="mb-2 fs-5 fw-semibold"
            style={{
              minHeight: 48,
              lineHeight: "1.28",
              display: "-webkit-box",
              WebkitLineClamp: 2,
              WebkitBoxOrient: "vertical",
              overflow: "hidden",
             
            }}
          >
            <Link to={`/blog/${article.slug}`} className="text-dark text-decoration-none">
              {article.title}
            </Link>
          </h4>
          <p
            className="line-clamp-3 text-secondary flex-grow-1 mb-2"
            style={{
              fontSize: "1rem",
              display: "-webkit-box",
              WebkitLineClamp: 3,
              WebkitBoxOrient: "vertical",
              overflow: "hidden",
               borderRadius:"8px"
            }}
          >
            {stripTags(article.description)}
          </p>
          <div className="d-flex align-items-center justify-content-between mt-2">
            <span className="text-muted small">
              {article.author ? `By ${article.author}` : "Admin"}{" "}
              {article.published_at
                ? new Date(article.published_at).toLocaleDateString()
                : ""}
            </span>
            <Link
              to={`/blog/${article.slug}`}
              className="read-more-modern btn btn-sm px-3 py-1 fw-semibold rounded-pill"
              style={{background:"#01132F", color:"white"}}
            >
              Read More →
            </Link>
          </div>
        </div>
      </div>
    </div>
  );

  // Loading skeleton
  if (loading) {
    return (
      <section className="news-section">
        <div className="container-fluid">
          <div className="text-center mb-3">
            <h3 className="sec-title">
              <FaRegNewspaper className="me-2" /> OUR LATEST ARTICLES
            </h3>
          </div>
          <div className="row">
            {[...Array(3)].map((_, index) => (
              <div className="col-lg-4 col-sm-6 mb-4" key={index}>
                <Skeleton height={310} />
              </div>
            ))}
          </div>
        </div>
      </section>
    );
  }

  // Error state
  if (error) {
    return <div className="alert alert-danger">Error: {error.message || error}</div>;
  }

  // Main render
  return (
    <section className="news-section py-1">
      <div className="container-fluid pb-0 pb-md-auto">
        <div className="text-center mb-3">
          <h3 className="sec-title">
            <FaRegNewspaper className="me-2" /> OUR LATEST ARTICLES
          </h3>
        </div>
        <div className="d-block px-2" style={{ position: "relative" }}>
          <OwlCarousel className="blog-carousel owl-theme" {...carouselOptions}>
            {articles.slice(0, 6).map(renderBlogCard)}
          </OwlCarousel>
        </div>
      </div>
    </section>
  );
};

export default BlogSection;
